import React from 'react';

// Components
import ComparisonBaseCell from '@/views/containers/comparison/ComparisonTable/ComparisonBaseCell';
import { Button } from '@capintel/component-lib/button';

export interface FieldConfig<T> {
  key: string;
  render: (item: T) => React.ReactNode;
}

interface Props<T> {
  item: T;
  fields: FieldConfig<T>[];
  onSelect?: (item: T) => void;
  selectLabel?: string;
}

function InstrumentComparisonCard<T extends { _id: string }>({ item, fields, onSelect, selectLabel }: Props<T>) {
  return (
    <div className="instrument-comparison-card">
      <div className="instrument-comparison-card-header">{fields[0].render(item)}</div>
      {fields.slice(1).map((field, idx) => (
        <ComparisonBaseCell key={field.key}>{field.render(item)}</ComparisonBaseCell>
      ))}
      {onSelect && (
        <div className="select-instrument">
          <Button variant="primary" size="small" onClick={() => onSelect(item)}>
            {selectLabel}
          </Button>
        </div>
      )}
    </div>
  );
}

export default InstrumentComparisonCard;
